/* tslint:disable */
/* eslint-disable */
/* Mocked in-memory implementation of LocationsClient for local development and UI wiring. */

import { CancelToken } from 'axios';
import {
  SuccessResponse_1OfIEnumerable_1OfLocationResponse,
  PostLocationResponse,
  LocationRequest,
  LocationResponse,
  GenericLocationResponse,
  SuccessResponse_1OfIEnumerable_1OfCountZonesResponse,
  CreateCountZoneRequest,
  SuccessResponse_1OfCountZoneDetailsResponse,
  UpdateCountZoneRequest,
  CountZonesForStoresResponse,
  GetItemsForCategoriesRequest,
  ItemsWithCategoryId,
  StockCheckLocationOrderRequest,
  StockCheckLocationItemsOrderRequest,
  SuccessResponse_1OfLocationResponse,
  SuccessResponse_1OfPostLocationResponse,
} from '../../types';

/* ---- Helper Functions ---- */

function delay(ms: number = 300): Promise<void> {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

function successResponse<T>(data: T): { data: T; success: boolean; message: string } {
  return { data, success: true, message: 'Success' };
}

/* ---- Mock Data ---- */

const mockLocations = [
  { id: 1, name: 'Back Storage', storeNumber: 'STORE001', isActive: true, itemCount: 45 },
  { id: 2, name: 'Front Counter', storeNumber: 'STORE001', isActive: true, itemCount: 20 },
  { id: 3, name: 'Walk-in Freezer', storeNumber: 'STORE001', isActive: true, itemCount: 30 },
];

const mockLocationItems = [
  { itemNumber: 'ITEM001', description: 'Whole Milk', locationId: 1 },
  { itemNumber: 'ITEM002', description: 'White Bread', locationId: 1 },
];

/* ---- Mocked Client Implementation ---- */

import { ILocationsClient } from '../../interfaces';
export class LocationsClientMocked implements ILocationsClient {
  constructor(baseUrl?: string) {}

  async getLocations(storeNumber: string, cancelToken?: CancelToken): Promise<SuccessResponse_1OfIEnumerable_1OfLocationResponse> {
    await delay();
    const locations = mockLocations.filter((l) => l.storeNumber === storeNumber);
    return successResponse(locations) as SuccessResponse_1OfIEnumerable_1OfLocationResponse;
  }

  async getlocation(locationId?: number, cancelToken?: CancelToken): Promise<SuccessResponse_1OfLocationResponse> {
    await delay();
    const location = mockLocations.find((l) => l.id === locationId) || mockLocations[0];
    return successResponse(location) as SuccessResponse_1OfLocationResponse;
  }

  async createlocation(body?: LocationRequest, cancelToken?: CancelToken): Promise<SuccessResponse_1OfPostLocationResponse> {
    await delay();
    const newLocation = {
      id: mockLocations.length + 1,
      name: body?.name || 'New Location',
      storeNumber: body?.storeNumber || 'STORE001',
      isActive: true,
      itemCount: 0,
    };
    mockLocations.push(newLocation);
    return successResponse({ id: newLocation.id, name: newLocation.name, storeNumber: newLocation.storeNumber, isSuccess: true }) as SuccessResponse_1OfPostLocationResponse;
  }

  async locationsPATCH(body?: LocationRequest, cancelToken?: CancelToken): Promise<void> {
    await delay();
    if (body?.id) {
      const location = mockLocations.find((l) => l.id === body.id);
      if (location) {
        location.name = body.name || location.name;
      }
    }
  }

  async locationsDELETE(locationId: number, force?: boolean, cancelToken?: CancelToken): Promise<void> {
    await delay();
    const index = mockLocations.findIndex((l) => l.id === locationId);
    if (index > -1) {
      mockLocations.splice(index, 1);
    }
  }

  async import4(body?: LocationRequest[], cancelToken?: CancelToken): Promise<void> {
    await delay();
  }

  async itemsGET(locationId: number, cancelToken?: CancelToken): Promise<LocationResponse[]> {
    await delay();
    const items = mockLocationItems.filter((i) => i.locationId === locationId);
    return items as unknown as LocationResponse[];
  }

  async itemsPUT(locationId: number, body?: string[], cancelToken?: CancelToken): Promise<void> {
    await delay();
  }

  async itemsDELETE(locationId: number, itemNumbers?: string[], cancelToken?: CancelToken): Promise<void> {
    await delay();
  }

  // ====== Auto-generated stub methods ======








    async updatelocation(body?: LocationRequest | undefined, cancelToken?: CancelToken | undefined): Promise<GenericLocationResponse> {
        throw new Error('Method updatelocation not implemented in mocked client');
    }

    async deletelocation(locationId?: number | undefined, cancelToken?: CancelToken | undefined): Promise<GenericLocationResponse> {
        throw new Error('Method deletelocation not implemented in mocked client');
    }

    async getCountZones(storeNumber: string, cancelToken?: CancelToken | undefined): Promise<SuccessResponse_1OfIEnumerable_1OfCountZonesResponse> {
        throw new Error('Method getCountZones not implemented in mocked client');
    }

    async createcountzone(body?: CreateCountZoneRequest | undefined, cancelToken?: CancelToken | undefined): Promise<GenericLocationResponse> {
        throw new Error('Method createcountzone not implemented in mocked client');
    }

    async countzoneGET(countZoneId: number, cancelToken?: CancelToken | undefined): Promise<SuccessResponse_1OfCountZoneDetailsResponse> {
        throw new Error('Method countzoneGET not implemented in mocked client');
    }

    async updatecountzone(body?: UpdateCountZoneRequest | undefined, cancelToken?: CancelToken | undefined): Promise<GenericLocationResponse> {
        throw new Error('Method updatecountzone not implemented in mocked client');
    }

    async deletestockcountzone(stockCountZoneId?: number | undefined, cancelToken?: CancelToken | undefined): Promise<GenericLocationResponse> {
        throw new Error('Method deletestockcountzone not implemented in mocked client');
    }

    async getavailablezones(storeNumbers?: string[] | undefined, cancelToken?: CancelToken | undefined): Promise<CountZonesForStoresResponse> {
        throw new Error('Method getavailablezones not implemented in mocked client');
    }

    async items(body?: GetItemsForCategoriesRequest | undefined, cancelToken?: CancelToken | undefined): Promise<ItemsWithCategoryId[]> {
        throw new Error('Method items not implemented in mocked client');
    }

    async reorderlocations(id: number, body?: StockCheckLocationOrderRequest[] | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        throw new Error('Method reorderlocations not implemented in mocked client');
    }

    async reorderitems(id: number, body?: StockCheckLocationItemsOrderRequest[] | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        throw new Error('Method reorderitems not implemented in mocked client');
    }

}
